import Menu from './menu';
import HeroContactTab from './hero-contact-tab';
import Hero from './hero';
import Forms from './forms';
import DesignConsistency from './design-consistency';
import Media from './media';
import Lazy from './lazy-loading';
import './lib/form-filter';
import './widgets';
import './links';
import './faq-search'; // added before accordeon search because it handles events triggered in accordeon search.
import './accordeon-search';
import './faq-link';
import '@babel/polyfill/noConflict';
import 'owl.carousel';
import '../../../jello/node_modules/bootstrap/js/dist/tab';

class JelloChild {
  /**
   * Sets necessary variables for this class
   * that are used throughout
   */
  constructor() {
    this.name = 'Jello Child Theme';
    this.menu = new Menu();
    this.heroContactTab = new HeroContactTab();
    this.hero = new Hero();
    this.media = new Media();
    this.Lazy = new Lazy();

    // Selectors
    this.vacancies = $('.vacancies');
    this.loadingOverlay = $('.loading-overlay');
    this.afas = $('.embed-responsive-item');
    this.main = $('main');
  }

  /**
   * Initializes all needed functions
   */
  init() {
    this.heroContactTab.init();
    this.hero.init();
    this.Lazy.init();
    this.setVacanciesFilter();
    this.hideShowVacanciesAfterAnimation();
    this.toggleAfasForm();
    this.modals();
    this.showreel();
    this.sustainableDevelopmentGoals();

    JelloChild.updateTimelineMeter();
    JelloChild.handleTimelineModalIntroductionTab();
    JelloChild.handleTimelineModalPagination();
    JelloChild.gfPriceBaseFix();
    JelloChild.handleScroll();
    
    Forms.init();
    DesignConsistency.init();
    
    $('html').attr('class', 'js');
    
    this.removeLoadingOverlay();
    JelloChild.scrollCenterX();
  }

  setVacanciesFilter() {
    if (!this.vacancies.length) {
      return;
    }

    $('.vacancies-filter').formFilter({
      target: '.item-vacancy',
      exception: $('.vacancies-filter').data('exception'),
    });
  }

  toggleAfasForm() {
    if (!this.afas.length) {
      return;
    }

    $('#show_afas_form').on('click', (e) => {
      e.preventDefault();
      let height = 1500;

      if (!this.media.large) {
        height = 3300;
      }

      $('#solliciteren').animate({
        height: `${height}px`,
      }, 500);
    });
  }

  hideShowVacanciesAfterAnimation() {
    if (!this.vacancies.length) {
      return;
    }

    $('.item-vacancy', this.vacancies).each((index, el) => {
      el.addEventListener('formfilter.hide', () => {
        $(el).animate({
          opacity: 0,
        }, 200, function takeOutOfFlow() {
          $(this).hide();
        });
      });

      el.addEventListener('formfilter.show', () => {
        $(el)
          .show()
          .animate({
            opacity: 1,
          }, 200);
      });
    });
  }

  removeLoadingOverlay() {
    this.loadingOverlay.hide(0);
  }

  modals() {
    $('.modal').on('show.bs.modal', () => {
      this.main.css('position', 'static');
    });

    $('.modal').on('hidden.bs.modal', () => {
      this.main.css('position', 'relative');
    });
  }

  showreel() { // eslint-disable-line class-methods-use-this
    const showreel = $('.showreel.owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      dots: false,
      nav: false,
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1200: {
          items: 3,
        },
      },
    });

    // Custom navigation
    $('.showreel-nav .nav-prev').on('click', () => showreel.trigger('prev.owl.carousel'));
    $('.showreel-nav .nav-next').on('click', () => showreel.trigger('next.owl.carousel'));
  }

  sustainableDevelopmentGoals() { // eslint-disable-line class-methods-use-this
    const goals = document.querySelectorAll('.sustainable-development-goals li');

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const viewportWidth = window.innerWidth;
        const halfOfViewportWidth = viewportWidth / 2;

        const position = entry.target.getBoundingClientRect();

        if (position.x < halfOfViewportWidth) {
          entry.target.classList.add('left');
        }
      });
    });

    goals.forEach((goal) => {
      resizeObserver.observe(goal);

      goal.addEventListener('click', (e) => {
        const currentlyVisible = e.currentTarget.classList.contains('show');

        goals.forEach(g => g.classList.remove('show'));

        if (!currentlyVisible) {
          e.currentTarget.classList.add('show');
        }

        e.preventDefault();
        e.stopImmediatePropagation();
      });
    });

    document.querySelector('body').addEventListener('click', (e) => {
      if (e.currentTarget.classList.contains('sustainable-development-goals-container')) {
        return;
      }

      goals.forEach(g => g.classList.remove('show'));
    });
  }

  static gfPriceBaseFix() {
    if (typeof toolkit === 'object' && toolkit.formID) {
      const gformId = toolkit.formID;

      $(`.page-toolkit-bestelpagina #gform_${gformId} .gfield_calculation input[id^=ginput_base_price]`).off().on('change', () => {
        const newTotal = JelloChild.calculateToolkitTotal();
        const formattedTotal = `€ ${newTotal.toFixed(2).replace('.', ',')}`;

        $(`#gform_${gformId} .ginput_container_custom_total .gform_hidden`).val(newTotal);
        $(`#gform_${gformId} .ginput_container_custom_total .ginput_custom_total`).text(formattedTotal);
      });
    }
  }
  
  static calculateToolkitTotal() {
    let total = 0;

    $('.page-toolkit-bestelpagina .ginput_container_product_calculation').each(function addToTotal() {
      const quantity = $('.ginput_quantity', this)[0].value;
  
      if (quantity > 0) {
        const valueInput = $('.gform_hidden[id^=ginput_base_price]', this);
        const calculatedValue = valueInput[0].value.replace('€ ', '').replace(/[^0-9,]/g, '').replace(',', '.');
  
        total += parseFloat(calculatedValue);
      }
    });

    return total;
  }

  static updateTimelineMeter() {
    $('.timeline-modal a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      const tab = e.target;
      const modal = $(e.target).parents('.modal')[0];
      const effortMeter = modal.querySelector('.meter-effort');
      const impactMeter = modal.querySelector('.meter-impact');
      const { effort, impact } = tab.dataset;

      if (effort && effortMeter) {
        effortMeter.style.setProperty('--value', effort);
      }

      if (impact && impactMeter) {
        impactMeter.style.setProperty('--value', impact);
      }
    });
  }

  static handleTimelineModalIntroductionTab() {
    const introductionTab = $('.timeline-modal .nav-timeline-introduction a[data-toggle="tab"]');
    
    introductionTab.on('shown.bs.tab', (e) => {
      const modal = $(e.target).parents('.modal')[0];
      const timelineMetersWrap = modal.querySelector('.meters-wrap');

      if (timelineMetersWrap) {
        timelineMetersWrap.style = 'opacity: 0;';
      }
    });

    introductionTab.on('hide.bs.tab', (e) => {
      const modal = $(e.target).parents('.modal')[0];
      const timelineMetersWrap = modal.querySelector('.meters-wrap');

      if (timelineMetersWrap) {
        timelineMetersWrap.style = null;
      }
    });
  }

  /**
   * Centers the scrollbar on elements which have overflowing content
   */
  static scrollCenterX() {
    const scrollables = document.querySelectorAll('.scroll-center-x');

    scrollables.forEach((scrollable) => {
      const scrollEl = scrollable;
      scrollEl.scrollLeft = (scrollEl.scrollWidth - scrollEl.offsetWidth) / 2;
    });
  }

  static handleTimelineModalPagination() {
    const paginationLinks = document.querySelectorAll('.timeline-modal-pagination a[data-trigger-tab]');
    
    paginationLinks.forEach((link) => {
      const target = link.dataset.triggerTab;

      link.addEventListener('click', (e) => {
        e.preventDefault();

        $(target).tab('show');
      });
    });
  }

  static handleScroll() {
    const limit = 50;
    const body = document.querySelector('body');

    // Initial
    body.classList.toggle('scroll', window.scrollY > limit);

    // Dynamic
    document.addEventListener('scroll', () => {
      const scrollDistance = window.scrollY;
      body.classList.toggle('scroll', scrollDistance > limit);
    });
  }
}

$(() => {
  const jc = new JelloChild();
  jc.init();
});
